module.exports = __webpack_public_path__ + "static/media/sociology-enrolled.1fa6058e.svg";